<div class="layout-container">
  <mat-drawer-container autosize class="h-screen">
    <mat-drawer #drawer [mode]="innerWidth <=900 ? 'over' : 'side'" [opened]="innerWidth > 900" class="w-fit">
      <section>
      <div class="h-screen ">
          <app-sidebar class="no-print" (menuClick)="innerWidth <=900 ? drawer.close() : null" [innerWidth]="innerWidth"
            [showMenuText]="showMenuText"></app-sidebar>
      </div>
    </section>
    </mat-drawer>
    <div class="flex-1 mt-4 menu-content mx-8 ">
      <app-header class="no-print" (menuClick)="drawer.toggle()"></app-header>
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-container>
</div>
